<template>
  <div class="hello">
    敬请期待...
  </div>
</template>

<script>

export default {
  name: 'Festival',
  props: {

  },
  data () {
    return {

    };
  },

  methods: {
  },

  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeDestroy () {},
  destroyed () {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
